import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
// import { Circles } from 'react-loader-spinner'; // Importing the loader component
import ResumeSkeleton from '../components/Loading/ResumeSkeleton';

const PrivateRoute = ({ element }) => {
    const { auth, loading } = useContext(AuthContext);

    if (loading) {
        return (
            <div className="loader-container" style={{ marginTop: '30vh' }}>
                {/* <ResumeSkeleton/> */}
            </div>
        )
    }

    return auth ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
